import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const SANDBOX_LANGUAGES = [
  "typescript",
  "javascript",
  "python",
] as const;
export type SandboxLanguage = (typeof SANDBOX_LANGUAGES)[number];

export const DEFAULT_CODE: Record<SandboxLanguage, string> = {
  typescript: `function handler(input: Record<string, unknown>): Record<string, unknown> {
  return {
    result: input,
  };
}`,
  javascript: `function handler(input) {
  return {
    result: input,
  };
}`,
  python: `def handler(input):
    return {
        "result": input,
    }`,
};

export const codeSandboxStep = defineStepConfig({
  type: "code_sandbox",
  name: "Code Sandbox",
  description: "Run custom code in an isolated Daytona sandbox",
  category: "Utility",

  inputSchema: z.record(z.string(), z.unknown()),

  outputSchema: z.record(z.string(), z.unknown()),

  configSchema: z.object({
    language: z.enum(SANDBOX_LANGUAGES).default("typescript"),
    code: z.string().max(100_000).default(DEFAULT_CODE.typescript),
    sandboxConfigId: z.string().uuid().optional(),
    inputKeys: z
      .array(
        z.object({
          key: z.string().regex(/^[a-z][a-z0-9_]*$/),
          type: z
            .enum(["string", "number", "boolean", "json", "any"])
            .default("any"),
          description: z.string().optional(),
          required: z.boolean().default(true),
        }),
      )
      .default([]),
    outputKeys: z
      .array(
        z.object({
          key: z.string().regex(/^[a-z][a-z0-9_]*$/),
          type: z
            .enum(["string", "number", "boolean", "json", "any"])
            .default("any"),
          description: z.string().optional(),
        }),
      )
      .default([{ key: "result", type: "any" }]),
    timeoutSeconds: z.number().min(1).max(60).default(10),
  }),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "2 minutes",
    retry: { maximumAttempts: 1 },
  },
});
